import React from "react";
import { useSelector } from "react-redux";

import { Theme } from "consts";
import ThemeA from "screens/thank-you/themeA";
import ThemeB from "screens/thank-you/themeB";
import { getSurveyQuestionnaire } from "screens/question/selectors";

const ThankYou = () => {
  const questionnaire = useSelector(getSurveyQuestionnaire);
  if (!questionnaire) {
    return null;
  }

  const ThankYouTheme = themes[questionnaire.theme];
  return <ThankYouTheme />;
};

const themes = {
  [Theme.RETRO]: ThemeA,
  [Theme.MODERN]: ThemeB,
};

export default ThankYou;
